import React from 'react'

export interface DraggableProps {
    isWrapped?: boolean
    id: string
    index: number
    droppableId: string
    childIds?: string[]
    isUserAdded: boolean
}

export const Draggable: React.FC<DraggableProps> = ({
    children,
    isWrapped,
}) => {
    return (
        <>
            {isWrapped ? (
                <div
                    className="wrappedDraggable"
                    data-testid="wrappedDraggable"
                >
                    {children}
                </div>
            ) : (
                <div>{children}</div>
            )}
        </>
    )
}
